import React from 'react';
import { Image } from 'react-bootstrap';
import { FacebookCircle, Linkedin, Twitter, Whatsapp } from '@styled-icons/boxicons-logos';

import { getEvento } from '../../../utils/eventosession';
function CompHeader(props) {
  const event =  getEvento()?getEvento():{};
  const eventImageName = () => {
    switch (props.language) {
      case "EN":
        return event.imagemeventoingles;
      case "ES":
        return event.imagemeventoespanhol;
      default:
        return event.imagemevento;
    }
  };
  const iconSize = 25;
  return (
    <header
      style={{
        background: "linear-gradient(180deg, rgba(0,0,0,0.3)0%, rgba(0,0,0,0.1)9%,rgba(255,255,255,1)100%)"
      }}
      className="d-flex flex-column pt-5">
      
      <Image 
      style={{boxShadow: "0px 10px 8px rgba(0,0,0,0.3)"}}
      rounded 
      fluid 
      className="mx-auto d-block mt-3 align-self-end"
      onError={
        (ev) => ev.target.src = `https://regtronweb.com.br/congressooficial/${eventImageName()}`
      }
      src={`https://regtronweb.com.br/credenciamentooficial/${eventImageName()}`} />
      <div
        style={{
          marginBottom: "-40px",
          borderRadius: "0px 0px 20px 20px",
          boxShadow: "0px 10px 8px rgba(0,0,0,0.3)"
        }}
        className="py-1 mx-auto d-flex flex-row text-secondary bg-white">
        <FacebookCircle className="mx-3" size={iconSize} />
        <Linkedin className="mx-3" size={iconSize} />
        <Twitter className="mx-3" size={iconSize} />
        <Whatsapp className="mx-3" size={iconSize} />
      </div>
    </header>
  );
}

export default CompHeader;
